<template>
  <div id="realTimeMap">
    <v-container fluid class="overrideContainer">
      <v-row>
        <v-col md="9" cols="12" lg="10" class="overrideCol">
          <div class="mapWrapper">
            <template v-if="mapType !== null">
                <GoogleRouteHistoryComponent v-if="mapType == 1" />
                <LeafletRouteHistoryComponent v-if="mapType == 0"/>
            </template>
            <div v-else>
              Initializing map...
            </div>
          </div>
        </v-col>
        <v-col v-if="mobileBereakPoint" class="mt-10" cols="12" md="3" lg="2">
           <RouteHistoryFilter />
        </v-col>
        <v-col v-else cols="12" md="3" lg="2">
           <RouteHistoryFilter :mapType="mapType"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import mapMixin from '../mapMixin.js'

export default {
  name: 'BaseRouteHistoryComponent',
  mixins: [mapMixin],
  components: {
    LeafletRouteHistoryComponent: () =>
      import('../routeHistory/LeafletRouteHistoryComponent'),
    GoogleRouteHistoryComponent: () =>
      import('../routeHistory/GoogleRouteHistoryComponent'),
    RouteHistoryFilter: () => import('../routeHistory/RouteHistoryFilter')
  },
  computed: {
    ...mapState('history', ['routes']),
    mobileBereakPoint() {
      return this.$vuetify.breakpoint.smAndDown
    }
  }
}
</script>

<style scoped>
.overrideContainer {
  padding: 0px !important;
}

.overrideCol {
  padding: 0px !important;
}
</style>
